import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { consumeTracker } from '../../utils/api/tracker'

const Tracker = () => {
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  const token = params.get('token')
  const redirectUrl = params.get('redirect_uri')

  if (redirectUrl === null) {
    window.location.href = '/'
  } else {
    if (token) {
      consumeTracker({ id: token })
    }

    window.location.href = redirectUrl
  }

  return (
    <div>
      CHILL AND RELAX, THIS IS A TRACKER PAGE, YOU WILL BE REDIRECT AUTOMATICALLY
    </div>
  )
}

export default Tracker
